import { render, staticRenderFns } from "./ImageChoiceItem.vue?vue&type=template&id=3c1a41aa&scoped=true"
import script from "./ImageChoiceItem.vue?vue&type=script&lang=js"
export * from "./ImageChoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a41aa",
  null
  
)

export default component.exports